<template>
  <div class="task-location">
    <template v-if="namespaceItem && !isNamespaceItemHide">
      <div style="display: flex; align-items: center; width: 100%;" @click.stop="selectItem(namespaceItem)">
        <div class="sidebar-menu-item__namespace-icon-wrap">
          <TirPmSvg
            :url="namespaceItem.IconUrl"
            class="sidebar-menu-item__namespace-icon"
            :color="namespaceItem.Color"
          />
        </div>
        <div class="menu__title_hidden" :class="{ menu__title_visible: true }">
          {{ truncateName(namespaceItem.Name) }}
        </div>

        <ChevronDownIcon
          v-if="(namespaceItem.QueueTasks.length > 0 || namespaceItem.Groups.length > 0) && !isShow"
          class="choose-project-dropdown_target_arrow"
          :class="{ open: false }"
        />
        <ChevronUpIcon
          v-if="(namespaceItem.QueueTasks.length > 0 || namespaceItem.Groups.length > 0) && isShow"
          class="choose-project-dropdown_target_arrow"
          :class="{ open: false }"
        />
      </div>
    </template>
    <template v-if="groupItem">
      <div
        :style="{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          paddingLeft: calculatePadding(groupItem) + 'rem',
        }"
         @click.stop="selectItem(groupItem)"
      >
        <FolderIcon class="menu__icon" style="width: 1rem; margin-right: 1rem" />
        <div class="menu__title_hidden">
          {{ truncateName(groupItem?.Name) }}
        </div>
        <ChevronDownIcon
         
          v-if="(groupItem.QueueTasks.length > 0 || groupItem.Groups.length > 0) && !isShow"
          class="choose-project-dropdown_target_arrow"
          :class="{ open: false }"
        />
        <ChevronUpIcon
          
          v-if="(groupItem.QueueTasks.length > 0 || groupItem.Groups.length > 0) && isShow"
          class="choose-project-dropdown_target_arrow"
          :class="{ open: false }"
        />
      </div>
    </template>
    <template v-if="queueItem">
      <div
        :style="{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          paddingLeft: calculatePadding(queueItem) + 'rem',
        }"
         @click.stop="selectItem(queueItem)"
      >
        <ListBulletIcon class="menu__icon" style="width: 1rem; margin-right: 1rem" />
        <div class="menu__title_hidden">
          {{ truncateName(queueItem?.Name) }}
        </div>
      </div>
    </template>

    <!--v-if="visibleIdx.includes(slot.option.Id)-->
  </div>
</template>

<script setup lang="ts">
// Импорты из Vue 3 Composition API
import { ref, computed, defineProps, defineEmits, onMounted, watch } from "vue";
import { TirPmDropdown, TirPmDropdownSizeEnum, TirPmIconView, TirPmSvg } from "tir-components";
import { GroupModel, NamespaceModel, QueueTasksModel } from "../sidebar/models";
import { PropType } from "vue";
import { ChevronDownIcon, FolderIcon, ListBulletIcon } from "tir-style-system/icons/outline";

import { ChevronUpIcon } from "tir-style-system/icons/solid";
// Определение пропсов компонента
const props = defineProps({
  items: {
    type: Array as PropType<(NamespaceModel | GroupModel | QueueTasksModel)[]>,
    default: [],
  },

  /** Элемент меню */
  item: {
    type: Object as PropType<NamespaceModel | GroupModel | QueueTasksModel>,
    required: true,
  },
  /** Открыт ли sidebar */
  isSidebarOpen: {
    type: Boolean,
  },
  /** Открыт ли sidebar */
  isNamespaceItemHide: {
    type: Boolean,
    default: false,
  },
  /** Уровень вложенности меню */
  level: {
    type: Number,
    default: 0,
  },
});
const visibleIdx = ref<Array<string>>([]);

/**Элемент рабочей области */
const namespaceItem = computed(() => (props.item.isNamespace() ? props.item : undefined));
/**Элемент группы */
const groupItem = computed(() => (props.item.isGroup() ? props.item : undefined));
/**Элемент очереди задач */
const queueItem = computed(() => (props.item.isQueue() ? props.item : undefined));
// // Определение эмиттеров событий компонента
const emits = defineEmits<{
  onChange: [NamespaceModel | GroupModel | QueueTasksModel, boolean]; // Событие обновления сообщения
}>();

const isShow = ref(false);
function calculatePadding(item) {
  let padding = 1;
  let currentItem = item;

  while (currentItem?.ParentGroupId) {
    padding += 1;
    currentItem = props.items.find((group) => group.Id === currentItem.ParentGroupId);
  }
  console.log(padding);
  return padding;
}
/**Выбор проекта */
function selectItem(project: NamespaceModel | GroupModel| QueueTasksModel) {
  // getProjects();
  isShow.value = !isShow.value;
  emits("onChange", project, isShow.value);
}

function truncateName(name: string, length: number = 28) {
  if (!name) return "";
  return name.length > length ? name.substring(0, length) + "..." : name;
}
</script>

<style lang="scss" scoped>
.menu__title_hidden {
  // padding-bottom: 1rem;
}

.task-location {
  display: flex;
  align-items: center;
  width: 100%;

  .sidebar-menu-item {
    &__namespace-icon {
      font-size: 1.125rem;
    }
    &__namespace-icon-wrap {
      align-self: flex-start;
      padding: 0.25rem;

      transition: padding 0.2s;
    }

    &__namespace-icon-wrap:hover {
      background: var(--neutral-translucent-5, rgba(39, 45, 55, 0.05));
      border-radius: 1rem;
    }
  }
}
</style>